define('views/content/distributor_managers',['require','views/base/list_page_view','views/components/distributor_manager/distributor_managers','collections/distributor_manager','text!templates/content/distributor_managers.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var DistributorManagersView = require('views/components/distributor_manager/distributor_managers');
    var DistributorManagersCollection = require('collections/distributor_manager');

    var temp = require("text!templates/content/distributor_managers.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'distributor-managers-page',
        titleKey: 'distributor_managers',

        setCollection: function () {
            this.collection = new DistributorManagersCollection();
        },

        onRender: function() {
            this.ListContainer.show(new DistributorManagersView({
                collection: this.collection
            }));
        }

    });
});
